import { CreativeTagEvent } from '../enums';
import { CreativeTagTrackingPayload, PayloadDatas } from '../types';

export type ComplexPayloadResult = {
  payload: CreativeTagTrackingPayload;
  endPoint: { url: string; method: 'GET' | 'POST' };
};

export type SingleResult = CreativeTagTrackingPayload | ComplexPayloadResult;
export type ArrayResult = Array<SingleResult>;

export type PayloadResult = SingleResult | ArrayResult;

export function isComplexPayloadResult(
  value: SingleResult
): value is ComplexPayloadResult {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  if (!('payload' in value) || !('endPoint' in value)) {
    return false;
  }
  const { endPoint, payload } = value as ComplexPayloadResult;
  if (
    typeof endPoint !== 'object' ||
    endPoint === null ||
    Array.isArray(endPoint)
  ) {
    return false;
  }
  if (typeof endPoint.url !== 'string') {
    return false;
  }
  if (endPoint.method !== 'GET' && endPoint.method !== 'POST') {
    return false;
  }
  if (
    typeof payload !== 'object' ||
    payload === null ||
    Array.isArray(payload)
  ) {
    return false;
  }
  return true;
}

export interface PayloadBuilderStrategy {
  setInitTime(timestamp: number): void;
  // Returns `null` when the event maps to no tracker for this strategy (e.g. the
  // meta-dsp strategy drops events outside its 3-tracker contract, or when the
  // enriched context is absent). Callers MUST guard against `null` before sending.
  buildPayload(
    creativeTagEvent: CreativeTagEvent,
    eventContext?: PayloadDatas,
    evt?: Event
  ): PayloadResult | null;
}
